import { render, staticRenderFns } from "./ggAndAe.vue?vue&type=template&id=222fbc1c&scoped=true"
import script from "./ggAndAe.vue?vue&type=script&lang=js"
export * from "./ggAndAe.vue?vue&type=script&lang=js"
import style0 from "./ggAndAe.vue?vue&type=style&index=0&id=222fbc1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222fbc1c",
  null
  
)

export default component.exports